import { render, staticRenderFns } from "./ReportFiles.vue?vue&type=template&id=027d5368&"
import script from "./ReportFiles.vue?vue&type=script&lang=js&"
export * from "./ReportFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('027d5368')) {
      api.createRecord('027d5368', component.options)
    } else {
      api.reload('027d5368', component.options)
    }
    module.hot.accept("./ReportFiles.vue?vue&type=template&id=027d5368&", function () {
      api.rerender('027d5368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Reports/ReportFiles.vue"
export default component.exports